import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
export interface Ibranch {
    bid: string;
    bnm: string;
}
/**
 * @todo 初始化設定值
 */
export interface LoginViewDataResp extends GeneralResp {
    branchList: Array<Ibranch>;
    captchaCodeBase64Src: string;
}

/**
 * @todo 登入檢查
 */
const LoginViewData = (): Promise<LoginViewDataResp> => {
    const url = RouteUrlList.API_LoginViewData.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<LoginViewDataResp>) => {
        return res.data;
    });
};

export default LoginViewData;
